import React, { useState } from 'react';
import { pricingPlans } from '../data/mockData';
import { Check } from 'lucide-react';

const PricingSection = () => {
  const [isYearly, setIsYearly] = useState(false);

  return (
    <section id="pricing" className="py-16 sm:py-24 px-3 sm:px-4 bg-gray-50 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <p className="text-[#25D366] font-medium mb-3 sm:mb-4 uppercase tracking-wide text-xs sm:text-sm">Pricing</p>
          <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Pricing for all kind of <span className="italic">businesses</span>
          </h2>
          <p className="text-gray-600 text-sm sm:text-lg max-w-2xl mx-auto px-2">
            Scalable and Customizable Pricing Options to Fit the Unique Needs of Every Business
          </p>
        </div>

        {/* Toggle */}
        <div className="flex justify-center mb-8 sm:mb-12">
          <div className="bg-white rounded-full p-1 sm:p-1.5 shadow-sm inline-flex border border-gray-100">
            <button
              onClick={() => setIsYearly(false)}
              className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-medium transition-all ${
                !isYearly ? 'bg-gray-900 text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setIsYearly(true)}
              className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-medium transition-all ${
                isYearly ? 'bg-gray-900 text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Yearly
              <span className="ml-1 text-[10px] sm:text-xs text-[#25D366]">Save 20%</span>
            </button>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {pricingPlans.map((plan, index) => {
            const colors = [
              { bg: 'bg-gradient-to-br from-blue-50 to-indigo-50', border: 'border-blue-100', accent: 'text-blue-500' },
              { bg: 'bg-gradient-to-br from-green-50 to-emerald-50', border: 'border-green-200', accent: 'text-[#25D366]' },
              { bg: 'bg-gradient-to-br from-yellow-50 to-amber-50', border: 'border-yellow-100', accent: 'text-yellow-600' },
            ];
            const color = colors[index];
            
            return (
              <div
                key={plan.id}
                className={`${color.bg} rounded-xl sm:rounded-2xl p-5 sm:p-8 border ${color.border} hover:shadow-xl transition-all relative ${
                  plan.popular ? 'ring-2 ring-[#25D366] shadow-lg' : ''
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="bg-[#25D366] text-white text-[10px] sm:text-xs font-medium px-2 sm:px-3 py-1 rounded-full">
                      Most Popular
                    </span>
                  </div>
                )}
                
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-600 mb-4 sm:mb-6 text-xs sm:text-sm">{plan.description}</p>
                
                <a
                  href="https://app.waatee.com/register"
                  className={`block w-full py-2.5 sm:py-3.5 rounded-full font-medium text-center transition-all mb-6 sm:mb-8 text-sm sm:text-base ${
                    plan.popular
                      ? 'bg-[#25D366] text-white hover:bg-[#1da851] shadow-md'
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  {plan.cta}
                </a>

                <div>
                  <p className="text-[10px] sm:text-xs text-gray-500 uppercase tracking-wide mb-3 sm:mb-4">What's included</p>
                  <ul className="space-y-2 sm:space-y-3">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 sm:gap-3">
                        <div className={`w-4 sm:w-5 h-4 sm:h-5 bg-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm`}>
                          <Check className={`w-2.5 sm:w-3 h-2.5 sm:h-3 ${color.accent}`} />
                        </div>
                        <span className="text-gray-700 text-xs sm:text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
